import { render, staticRenderFns } from "./TagsTab.vue?vue&type=template&id=29ae37e4"
import script from "./TagsTab.vue?vue&type=script&lang=js"
export * from "./TagsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports